import { Component, ViewChild, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PlantDataDto } from 'src/app/dtos/plant-data-dto';
import { AddressControlComponent } from 'src/app/shared/address-control/address-control.component';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { Location } from '@angular/common';

@Component({
    selector: 'app-inventary-add',
    templateUrl: './inventary-add.component.html',
    styleUrls: ['./inventary-add.component.scss']
})

export class InventaryAddComponent implements OnInit {

    id: any;
    form: FormGroup;
    submitted: boolean;
    plant: PlantDataDto;
    submitButtonText = 'GENERAL.LABELS.CREATE';
    isEditing: boolean;
    @ViewChild('addressControl') addressControl: AddressControlComponent;

    constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private apiService: ApiService,
        private messageService: MessageService, private location: Location) {
        this.id = this.activatedRoute.snapshot.params['id'];
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            name: ['', Validators.required]
        });

        if (this.id) {
            this.isEditing = true;
            this.submitButtonText = 'GENERAL.LABELS.EDIT';
            this.apiService.get('api/plant/dto/' + this.id).subscribe((data: any) => {
                this.plant = data.data;
                this.addressControl.setAddressData(this.plant);
                this.addressControl.setLatLong(this.plant.lat, this.plant.long);
            });
        }
    }

    get controls() { return this.form.controls; }

    back() {
        this.location.back();
    }

    onSubmit() {
        this.submitted = true;
        const addressControlData = this.addressControl.getAddressData();
        if (this.form.invalid || addressControlData.isInvalid) {
            return;
        }

        const customer: PlantDataDto = this.form.value as PlantDataDto;
        const address: PlantDataDto = addressControlData.values as PlantDataDto;
        const model = Object.assign({}, customer, address);

        if (this.isEditing) {
            model.id = this.id;
            this.apiService.put('api/plant/updateFromDto', model).subscribe(() => {
                this.messageService.success('USERS.MESSAGES.SUCCESS', 'PLANT.MESSAGES.PLANT_UPDATED');
                this.location.back();
            });
        } else {
            this.apiService.post('api/plant/saveFromDto', model).subscribe((response:any) => {
                this.messageService.success('USERS.MESSAGES.SUCCESS', 'PLANT.MESSAGES.PLANT_SAVED');
                this.location.back();
            });
        }
    }

}
